import { useEffect, useRef } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "sonner";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { TheGoal } from "@/components/landing/TheGoal";
import { MarqueeBand } from "@/components/landing/MarqueeBand";
import { NotElevatorPitch } from "@/components/landing/NotElevatorPitch";
import { FiveSteps } from "@/components/landing/FiveSteps";
import { TheRule } from "@/components/landing/TheRule";
import { Debrief } from "@/components/landing/Debrief";
import { Author } from "@/components/landing/Author";
import { CloseCTA } from "@/components/landing/CloseCTA";

const LOGO =
  "https://customer-assets.emergentagent.com/job_d8bde34f-08da-465f-b45b-a2f93a9d58b4/artifacts/hw02tjz7_IntegrityGO%20logo%201.jpg";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisRef.current = lenis;

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const scrollToForm = () => {
    const target = document.getElementById("lead-form-anchor");
    if (lenisRef.current && target) {
      lenisRef.current.scrollTo(target, { offset: -110 });
    } else if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="App relative">
      <div className="noise-overlay" aria-hidden />
      <Toaster position="top-center" richColors />

      <Header onCtaClick={scrollToForm} />

      <main>
        <Hero />
        <TheGoal />
        <MarqueeBand
          variant="acid"
          items={["No Script", "No Pitch", "No Elevator Pitch", "Listen First"]}
        />
        <NotElevatorPitch />
        <FiveSteps />
        <TheRule />
        <Debrief />
        <Author />
        <CloseCTA scrollToForm={scrollToForm} />
      </main>

      <footer className="border-t-2 border-ink bg-white py-10" data-testid="site-footer">
        <div className="mx-auto flex max-w-[1400px] flex-col items-center justify-between gap-5 px-5 md:flex-row md:px-10">
          <img src={LOGO} alt="Integrity Go" className="h-9 w-auto object-contain" />
          <p className="font-mono text-xs font-medium uppercase tracking-[0.16em] text-ink/50">
            © {new Date().getFullYear()} Integrity Go · The Dope Conversation Starter
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;
